export function updateInnerText(elements, text) {
    elements.forEach(element => {
        element.innerText = text;
    });
}